import React from 'react';
import { Ticket, TicketStatus, TicketType, AvailableTicket as AvailableTicketType } from '@/lib/OrderApi';
import EntranceTicket from './ticket-types/EntranceTicket';
import TapConnectTicket from './ticket-types/TapConnectTicket';
import CashCardTicket from './ticket-types/CashCardTicket';

interface AvailableTicketProps {
  ticket: Ticket;
}

const AvailableTicket: React.FC<AvailableTicketProps> = ({ ticket }) => {
  if (ticket.ticketStatus !== TicketStatus.available) {
    return null;
  }

  if (ticket.ticketType === TicketType.TapConnect) {
    return <TapConnectTicket ticket={ticket as AvailableTicketType} />;
  }

  if (ticket.ticketType === TicketType.CashCard) {
    return <CashCardTicket ticket={ticket as AvailableTicketType} />;
  }

  return <EntranceTicket ticket={ticket as AvailableTicketType} />;
};

export default AvailableTicket;       